import React from 'react';

import { Box, Typography } from '@mui/material';

import { CancelRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';

import { StyledDrawer } from '../Drawer/index.style';

const BottomSheet = ({ title, open, onClose, children }) => (
  <StyledDrawer
    anchor="bottom"
    padding="0px"
    maxWidthContent="100%"
    minWidth="auto"
    open={open}
    onClose={onClose}
    isFullBorderRadius
  >
    <Box className="drawer-title-select">
      <Typography className="title-bottom-sheet">{title}</Typography>
      <CancelRounded sx={{ color: COLOR.darkV2[32] }} onClick={onClose} />
    </Box>
    <Box className="drawer-content">{children}</Box>
  </StyledDrawer>
);

export default BottomSheet;
